// extracted by mini-css-extract-plugin
export default {"MainNav":"MainNav_MainNav__IG2rf","Logo":"MainNav_Logo__FhsTc","NavBar":"MainNav_NavBar__ZuBZB"};